import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  ScatterController,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  PointElement,
  LinearScale,
  LineElement,
  ScatterController,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({
  options,
  data,
  height,
  style,
  showDataLabels = false,
}) => {
  const pluginArray = [];

  if (showDataLabels) {
    pluginArray.push(ChartDataLabels);
  }
  return (
    <Line
      height={height}
      options={options}
      data={data}
      style={style}
      plugins={pluginArray}
    />
  );
};

export default LineChart;
